const GUEST_AUTH_PATHS = new Set([
  '/login',
  '/login/two-factor-authentication',
  '/forgot-password',
  '/reset-password',
]);

export const isGuestAuthRoute = (pathname: string): boolean =>
  GUEST_AUTH_PATHS.has(pathname) || pathname.startsWith('/login/');
